export default __webpack_public_path__ + "static/media/icons8-javascript.081325c6.svg";